var React = require('react');

function AbmLogoSinglePin (props) {
    return React.createElement("svg",props,[React.createElement("path",{"className":"pin__pin","d":"M230 47.39c-63.07 0-114.2 51.79-114.2 115.7 0 63.89 49.98 138.1 114.2 249.5 64.22-111.4 114.2-185.6 114.2-249.5 0-63.89-51.12-115.7-114.2-115.7zm0 154.4c-22.62 0-40.95-18.57-40.95-41.49 0-22.91 18.33-41.49 40.95-41.49s40.95 18.57 40.95 41.49c0 22.91-18.33 41.49-40.95 41.49z","fill":"hsl(128,27%,52%)","fillOpacity":".88","key":0}),React.createElement("path",{"className":"pin__dot","d":"M230 118.8c-22.62 0-40.97 18.67-40.97 41.58s18.35 41.43 40.97 41.43 40.97-18.52 40.97-41.43S252.62 118.8 230 118.8z","fillOpacity":".949","fillRule":"evenodd","fill":"#eee","key":1})]);
}

AbmLogoSinglePin.defaultProps = {"version":"1.2","viewBox":"0 0 460 460"};

module.exports = AbmLogoSinglePin;

AbmLogoSinglePin.default = AbmLogoSinglePin;
